import { useFeatureFlag } from "utils";

import { FEATURE_FLAGS } from "consts";

// Read from the FeatBit project shared with the API, which applies the same flag to the CM figures.
export const useCmBreakdownFlag = (): boolean => useFeatureFlag(FEATURE_FLAGS.SOIL_SIGHT_CM_BREAKDOWN, { project: "common" }).isEnabled;
